/** 
 * @param {HTMLElement} element 
 * @param {?(el: HTMLElement) => boolean} filter
 * @returns {HTMLElement[]}
 */
export const getSiblings = (element, filter) => {
    const siblings = [];
    const parent = element.parentNode;
    let sibling = parent.firstChild;

    do {
        // Skip text nodes
        if (sibling.nodeType === 3)
            continue;

        if (!filter || filter(sibling))
            siblings.push(sibling);
    } while (sibling = sibling.nextSibling);
    
    return siblings;
}
